import { $ } from "@olmokit/dom";
import {
  glide,
  Swipe,
  Autoplay,
  Controls,
  // AutoHeight,
  Sync,
  LazyLoad,
} from "@olmokit/core/glide";
import "components/DownloadsBox";
import "components/Btn/Download";
import "utils/slider-controls.scss";
import "./index.scss";

/**
 * Component: Slider display
 *
 * @param {string} rootSelector
 */
export default function SliderComposite(rootSelector) {
  const $root = $(rootSelector);
  const $imgs = $(".SliderComposite:imgs", $root);
  const $info = $(".SliderComposite:info", $root);
  const $downloads = $(".SliderComposite:downloads", $root);

  const info = glide($info, {
    loop: false,
    autoplay: 7000,
    rewind: true,
    rewindDuration: 2000,
  });
  const imgs = glide($imgs, {
    loop: false,
    autoplay: 7000,
    rewind: true,
    rewindDuration: 2000,
    sync: info,
  });

  imgs.mount({ Swipe, Autoplay, LazyLoad, Sync /* AutoHeight, */ });
  info.mount({ Swipe, Autoplay, Controls /* AutoHeight  */ });

  // downlaods are there only for logged in users
  if ($downloads) {
    const downloads = glide($downloads, {
      loop: false,
      sync: info,
    });
    downloads.mount({ Swipe, Sync });
  }
}
